// =============================================
// CHANGE THESE VALUES TO SET YOUR LOGIN
// =============================================
const AUTH_USERNAME = "mhansell";
const AUTH_PASSWORD = "1L0v3g04n42019!";

// Session keys for localStorage
const SESSION_KEY = "binary_game_session";
const USERNAME_KEY = "binary_game_username";

export const validateCredentials = (username, password) => {
  return username === AUTH_USERNAME && password === AUTH_PASSWORD;
};

export const createSession = (username) => {
  const token = btoa(`${Date.now()}_binary_game_authenticated`);
  localStorage.setItem(SESSION_KEY, token);
  localStorage.setItem(USERNAME_KEY, username);
  return token;
};

export const checkSession = () => {
  return localStorage.getItem(SESSION_KEY) !== null;
};

export const getSessionUsername = () => {
  return localStorage.getItem(USERNAME_KEY);
};

export const clearSession = () => {
  localStorage.removeItem(SESSION_KEY);
  localStorage.removeItem(USERNAME_KEY);
};

export default {
  validateCredentials,
  createSession,
  checkSession,
  getSessionUsername,
  clearSession
};
